import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { useDeleteSharedKnowledgeFileService } from '@/services/sharedFiles';
import { type FC } from 'react';

export const DeleteFileModal: FC<{
  fileId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}> = ({ fileId, open, onOpenChange }) => {
  const { deleteFile } = useDeleteSharedKnowledgeFileService();

  const handleDelete = () => {
    deleteFile(fileId);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete File</DialogTitle>
          <DialogDescription>
            Delete the file from the shared knowledge.
          </DialogDescription>
        </DialogHeader>
        <Text>Are you sure you want to delete this file?</Text>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={handleDelete}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
